<template>
  <component :is="layout">
      <router-view :layout.sync="layout"/>
  </component>
</template>

<script>
import AuthLayout from './layouts/auth'

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      layout: AuthLayout
    }
  }
}
</script>
